import React, { KeyboardEvent, forwardRef } from 'react';

interface MessageInputProps {
  value: string;
  onChange: (value: string) => void;
  onSend: (message: string) => void;
  disabled?: boolean;
}

const MessageInput = forwardRef<HTMLInputElement, MessageInputProps>(({
  value,
  onChange,
  onSend,
  disabled = false
}, ref) => {
  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (value.trim()) {
        onSend(value);
      }
    }
  };

  const handleSendClick = () => {
    if (value.trim() && !disabled) {
      onSend(value);
    }
  };

  return (
    <div className="app-message-input-area">
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={handleKeyPress}
        disabled={disabled}
        placeholder={disabled ? "Thinking…" : "Ask about a position, a roll, the market…"}
        className="app-message-input"
      />
      <button
        onClick={handleSendClick}
        disabled={disabled || !value.trim()}
        className="app-message-send-button"
        aria-label="Send message"
      >
        <span>Send</span>
        <svg
          className="app-message-send-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
        </svg>
      </button>
    </div>
  );
});

export default MessageInput;